import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { Size } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SizeService extends TmsWebBaseEditService<Size, Size> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('Size', $localize`Size`, httpService, notificationService);
  }
}
